import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../service/shared/axiosBaseQuery';
import { IUser, UserAPIResponse } from './User.model';
import { fromBase64, toBase64 } from '../../shared/util/base64';
import Environment from '../../shared/constants/Environment';

export const UserAPI = createApi({
  reducerPath: 'user',
  baseQuery: axiosBaseQuery({ baseUrl: Environment.backendAPIUser }),
  tagTypes: ['update-rights-user', 'settings-data'],
  endpoints(build) {
    return {
      getUser: build.query<IUser | undefined, string>({
        query: (userUUID) => ({ url: `/${toBase64(userUUID)}` }),
        transformResponse: (response: UserAPIResponse) => {
          return {
            ...response,
            id: fromBase64(response.id),
            encodedId: response.id,
          };
        },
      }),
      getMyUser: build.query<IUser | undefined, void>({
        query: () => ({ url: '/self' }),
        transformResponse: (response: UserAPIResponse) => {
          return {
            ...response,
            id: fromBase64(response.id),
            encodedId: response.id,
          };
        },
      }),
    };
  },
});

export default UserAPI;
